export const Ordered_Numbers_FA = [
  { value: 1, fa: 'اول' },
  { value: 2, fa: 'دوم' },
  { value: 3, fa: 'سوم' },
  { value: 4, fa: 'چهارم' },
  { value: 5, fa: 'پنجم' },
  { value: 6, fa: 'ششم' },
  { value: 7, fa: 'هفتم' },
  { value: 8, fa: 'هشتم' },
  { value: 9, fa: 'نهم' },
  { value: 10, fa: 'دهم' },
  { value: 11, fa: 'یازدهم' },
  { value: 12, fa: 'دوازدهم' },
  { value: 13, fa: 'سیزدهم' },
  { value: 14, fa: 'چهاردهم' },
  { value: 15, fa: 'پانزدهم' },
  { value: 16, fa: 'شانزادهم' },
  { value: 17, fa: 'هفدهم' },
  { value: 18, fa: 'هجدهم' },
  { value: 19, fa: 'نوزدهم' },
  { value: 20, fa: 'بیستم' },
  { value: 21, fa: 'بیست و یکم' },
  { value: 22, fa: 'بیست و دوم' },
  { value: 23, fa: 'بیست و سوم' },
  { value: 24, fa: 'بیست و چهارم' },
  { value: 25, fa: 'بیست و پنجم' },
  { value: 26, fa: 'بیست و ششم' },
  { value: 27, fa: 'بیست و هفتم' },
  { value: 28, fa: 'بیست و هشتم' },
  { value: 29, fa: 'بیست و نهم' },
  { value: 30, fa: 'بیست و نهم' },
  { value: 31, fa: 'سی و یکم' },
  { value: 32, fa: 'سی و دوم' },
  { value: 33, fa: 'سی و سوم' },
  { value: 34, fa: 'سی و چهارم' },
  { value: 35, fa: 'سی و پنجم' },
  { value: 36, fa: 'سی و ششم' },
  { value: 37, fa: 'سی و هفتم' },
  { value: 38, fa: 'سی و هشتم' },
  { value: 39, fa: 'سی و نهم' },
  { value: 40, fa: 'چهل' },
  { value: 41, fa: 'چهل و یکم' },
  { value: 42, fa: 'چهل و دوم' },
  { value: 43, fa: 'چهل و سوم' },
  { value: 44, fa: 'چهل و چهارم' },
  { value: 45, fa: 'چهل و پنجم' },
  { value: 46, fa: 'چهل و ششم' },
  { value: 47, fa: 'چهل و هفتم' },
  { value: 48, fa: 'چهل و هشتم' },
  { value: 49, fa: 'چهل و نهم' },
  { value: 50, fa: 'پنجاه ام' },
  { value: 51, fa: 'پنجاه و یک' },
  { value: 52, fa: 'پنجاه و دو' },
  { value: 53, fa: 'پنجاه و سه' },
  { value: 54, fa: 'پنجاه و چهار' },
  { value: 55, fa: 'پنجاه و پنج' },
  { value: 56, fa: 'پنجاه و شش' },
  { value: 57, fa: 'پنجاه و هفت' },
  { value: 58, fa: 'پنجاه و هشت' },
  { value: 59, fa: 'پنجاه و نه' },
  { value: 60, fa: 'شصت ام' },
  { value: 61, fa: 'شصت و یکم' },
  { value: 62, fa: 'شصت و دوم' },
  { value: 63, fa: 'شصت و سوم' },
  { value: 64, fa: 'شصت و چهارم' },
  { value: 65, fa: 'شصت و پنجم' },
  { value: 67, fa: 'شصت و ششم' },
  { value: 67, fa: 'شصت و هفتم' },
  { value: 68, fa: 'شصت و هشتم' },
  { value: 69, fa: 'شصت و نهم' },
  { value: 70, fa: 'هفتادم' },
  { value: 60, fa: 'هفتاد و یکم' },
  { value: 60, fa: 'هفتاد و دوم' },
  { value: 60, fa: 'هفتاد و سوم' },
  { value: 60, fa: 'هفتاد و چهارم' },
  { value: 60, fa: 'هفتاد و پنجم' },
  { value: 60, fa: 'هفتاد و ششم' },
  { value: 60, fa: 'هفتاد و هفتم' },
  { value: 60, fa: 'هفتاد و هشتم' },
  { value: 60, fa: 'هفتاد و نهم' },
  { value: 60, fa: 'هشتادم' },
];

export const findPersianDefinition = (value) => {
  const findValue = Ordered_Numbers_FA.find((number) => number.value === value);
  return findValue.fa;
};
